var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"dark":"","prominent":"","src":'data:image/png;base64,' + _vm.imageUrl,"flat":"","tile":"","height":"400px"},scopedSlots:_vm._u([{key:"img",fn:function(ref){
var props = ref.props;
return [_c('v-img',_vm._b({staticClass:"primary\n      lighten-2",attrs:{"fill":""}},'v-img',props,false))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }